import React from 'react'
import NavWidget from '../../../../widget/Nav/NavWidget'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import GuestsPageWidget from './guestsPageWidget'

function Guests() {
  return (
    <div>
        <NavWidget/>
        <div className='row'>
            <div className='col s12 m2 transparent'>
                <SidebarWidget/>
            </div>
            <div className='col s12 m10'>
                {/* <div className='container'> */}
                   <GuestsPageWidget/>
                {/* </div> */}
            </div>
        </div>
    </div>
  )
}

export default Guests